<template>
	<div id="wrapper">
		<SidebarView :fixedAssets="true" :fixedAssetsVisible="true" :disposedAssetsReport="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<div class="card card-shape home-box mb-3">
						<div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
							<h6 class="m-0 fw-bold text-green">Disposed Assets</h6>
							<b-button class="akkurate-green-btn btn-size text-white" :disabled="exporting" @click="exportExcel">
								<b-spinner v-if="exporting" small class="me-1" />
								Export Excel
							</b-button>
						</div>
						<div class="card-body">
							<div class="row g-2 mb-3 align-items-end">
								<div class="col-md-3">
									<label class="akkurate-dark small">Start date <span class="text-danger">*</span></label>
									<b-form-input v-model="filters.start_date" type="date" class="field-container" />
								</div>
								<div class="col-md-3">
									<label class="akkurate-dark small">End date <span class="text-danger">*</span></label>
									<b-form-input v-model="filters.end_date" type="date" class="field-container" />
								</div>
								<div class="col-md-auto d-flex gap-2">
									<b-button class="akkurate-green-btn btn-size text-white" @click="load">
										<font-awesome-icon class="me-1" :icon="['fas', 'search']" />
										Load
									</b-button>
								</div>
							</div>

							<div v-if="error" class="alert alert-danger py-2 small mb-2">{{ error }}</div>

							<b-table
								striped
								bordered
								responsive
								:busy="busy"
								:items="rows"
								:fields="fields"
								show-empty
								class="table_text_size"
							/>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>
		<ChatBot />
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";
import ApiService from "@/core/services/api.service";

export default {
	name: "DisposedAssetsReport",
	components: { SidebarView, TopbarView, ChatBot },
	data() {
		return {
			busy: false,
			exporting: false,
			error: "",
			rows: [],
			fields: [
				{ key: "asset_tag", label: "Tag" },
				{ key: "asset_name", label: "Asset" },
				{ key: "branch", label: "Branch" },
				{ key: "category", label: "Category" },
				{ key: "disposal_date", label: "Disposal date" },
				{ key: "disposal_value", label: "Disposal value" },
				{ key: "reason", label: "Reason" },
			],
			filters: { start_date: "", end_date: "" },
		};
	},
	methods: {
		params() {
			return {
				start_date: this.filters.start_date || undefined,
				end_date: this.filters.end_date || undefined,
			};
		},
		async load() {
			this.error = "";
			if (!this.filters.start_date || !this.filters.end_date) {
				this.error = "Start date and end date are required.";
				return;
			}
			this.busy = true;
			this.$Progress.start();
			try {
				const res = await ApiService.query("/reports/assets/disposed", {
					params: { ...this.params(), per_page: 30 },
				});
				const body = res.data;
				this.rows = body.data || body || [];
			} catch (e) {
				this.rows = [];
				this.error = e.response?.data?.message || "Could not load disposed assets.";
			} finally {
				this.busy = false;
				this.$Progress.finish();
			}
		},
		async exportExcel() {
			this.error = "";
			if (!this.filters.start_date || !this.filters.end_date) {
				this.error = "Start date and end date are required.";
				return;
			}
			this.exporting = true;
			try {
				const res = await ApiService.query("/reports/assets/disposed/export-excel", {
					params: this.params(),
				});
				const url = res.data?.download_url;
				if (url) {
					window.open(url, "_blank", "noopener,noreferrer");
					toast.fire({ icon: "success", title: res.data?.message || "Export ready" });
				} else {
					this.error = "Export did not return a download URL.";
				}
			} catch (e) {
				if (e.response?.status === 422 && e.response?.data?.errors) {
					this.error = Object.values(e.response.data.errors).flat().join(" ");
				} else {
					this.error = e.response?.data?.message || "Export failed.";
				}
			} finally {
				this.exporting = false;
			}
		},
	},
};
</script>

